import { render, staticRenderFns } from "./SafetyWorkPlanManageDetail.vue?vue&type=template&id=dcef5fa2&"
import script from "./SafetyWorkPlanManageDetail.vue?vue&type=script&lang=js&"
export * from "./SafetyWorkPlanManageDetail.vue?vue&type=script&lang=js&"
import style0 from "./SafetyWorkPlanManageDetail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports